$(document).on('turbolinks:load', function() {
  // Show server-side validation errors if any
  var form = $('#admin-diary-edit-form');
  if (form.length === 0) return;

  // Check for server-side errors from data attributes
  if (form.data('has-title-error') === true) {
    $('.error-title').removeClass('d-none');
  }
  if (form.data('has-content-error') === true) {
    $('.error-content').removeClass('d-none');
  }

  // Form submission validation
  form.on('submit', function(e) {
    var title = $('#diary_title').val();
    var content = $('#diary_content').val();
    var isValid = true;

    // Validate title
    if (!title || !title.trim()) {
      $('.error-title').removeClass('d-none');
      isValid = false;
    } else {
      $('.error-title').addClass('d-none');
    }

    // Validate content
    if (!content || !content.trim()) {
      $('.error-content').removeClass('d-none');
      isValid = false;
    } else {
      $('.error-content').addClass('d-none');
    }

    if (!isValid) {
      e.preventDefault();
      // Scroll to first error
      var firstError = $('.error-title, .error-content').not('.d-none').first();
      if (firstError.length > 0) {
        $('html, body').animate({
          scrollTop: firstError.offset().top - 100
        }, 500);
      }
      return false;
    }
  });

  // Clear error messages when user starts typing
  $('#diary_title').on('input', function() {
    if ($(this).val().trim()) {
      $('.error-title').addClass('d-none');
    }
  });

  $('#diary_content').on('input', function() {
    if ($(this).val().trim()) {
      $('.error-content').addClass('d-none');
    }
  });

  // File input preview functionality
  var fileInput = $('#diary_images_input');
  var fileNameDisplay = $('#file-name');
  var previewContainer = $('#image-preview-container');

  if (fileInput.length > 0 && fileNameDisplay.length > 0 && previewContainer.length > 0) {
    fileInput.off('change').on('change', function(e) {
      var files = e.target.files;
      if (files.length > 0) {
        previewContainer.empty();
        
        if (files.length === 1) {
          fileNameDisplay.text(files[0].name + ' が選択されました');
        } else {
          fileNameDisplay.text(files.length + 'つのファイルが選択されました');
        }

        Array.from(files).slice(0, 3).forEach(function(file) {
          if (file.type.startsWith('image/')) {
            var reader = new FileReader();
            reader.onload = function(e) {
              var div = $('<div>').addClass('position-relative').css({
                'width': '150px',
                'height': '150px'
              });
              var img = $('<img>')
                .addClass('w-100 h-100 mobject-fit rounded border')
                .css('object-fit', 'cover')
                .attr('src', e.target.result)
                .attr('alt', 'プレビュー');
              div.append(img);
              previewContainer.append(div);
            };
            reader.readAsDataURL(file);
          }
        });
      }
    });
  }
});

